import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=3a4f5f6b&scoped=true&"
import script from "./MenuTop.vue?vue&type=script&lang=js&"
export * from "./MenuTop.vue?vue&type=script&lang=js&"
import style0 from "./MenuTop.vue?vue&type=style&index=0&id=3a4f5f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f5f6b",
  null
  
)

export default component.exports